import type { MisconceptionDefinition } from '../types'

export const GELD_KORTING: MisconceptionDefinition[] = [
  {
    id: 'geld.surcharge-is-answer',
    label: 'Verwart opslag met nieuwe prijs',
    module: 'Geld',
    description:
      'Leerling geeft het opslagbedrag als antwoord in plaats van de nieuwe prijs (of omgekeerd).',
    typicalFamilies: ['GELD-GELD-KORTING'],
  },
  {
    id: 'geld.percent-equals-amount',
    label: 'Denkt dat percentage gelijk is aan bedrag',
    module: 'Geld',
    description:
      'Leerling denkt dat bijv. 25% korting altijd €25 is, ongeacht het bedrag.',
    typicalFamilies: ['GELD-GELD-KORTING'],
  },
  {
    id: 'geld.add-instead-of-subtract',
    label: 'Telt korting op in plaats van af te trekken',
    module: 'Geld',
    description:
      'Leerling telt het kortingsbedrag bij de prijs op in plaats van het af te trekken.',
    typicalFamilies: ['GELD-GELD-KORTING'],
  },
  {
    id: 'geld.confuses-discount-with-new-price',
    label: 'Verwart nieuwe prijs met kortingsbedrag',
    module: 'Geld',
    description:
      'Leerling geeft de nieuwe prijs als het kortingsbedrag of omgekeerd.',
    typicalFamilies: ['GELD-GELD-KORTING'],
  },
  {
    id: 'geld.wrong-percentage-calc',
    label: 'Berekent percentage verkeerd',
    module: 'Geld',
    description:
      'Leerling maakt een rekenfout bij het berekenen van het percentage van een bedrag.',
    typicalFamilies: ['GELD-GELD-KORTING'],
  },
  {
    id: 'geld.subtract-instead-of-add',
    label: 'Trekt opslag af in plaats van op te tellen',
    module: 'Geld',
    description:
      'Leerling trekt het opslagbedrag af van de prijs in plaats van het erbij op te tellen.',
    typicalFamilies: ['GELD-GELD-KORTING'],
  },
  {
    id: 'geld.percentage-van-nieuwe-prijs',
    label: 'Berekent percentage van de nieuwe prijs i.p.v. de oude',
    module: 'Geld',
    description:
      'Leerling berekent het percentage van de nieuwe prijs en telt dat erbij op, in plaats van terug te rekenen naar de oude prijs.',
    typicalFamilies: ['GELD-GELD-TERUGREKENEN'],
  },
  {
    id: 'geld.dubbele-korting',
    label: 'Past korting dubbel toe',
    module: 'Geld',
    description:
      'Leerling trekt de korting er nog een keer af van de al-gereduceerde prijs.',
    typicalFamilies: ['GELD-GELD-TERUGREKENEN'],
  },
  {
    id: 'geld.percentage-als-vast-bedrag',
    label: 'Behandelt percentage als vast bedrag',
    module: 'Geld',
    description:
      'Leerling telt het percentagegetal op als vast bedrag (bijv. 20% = €20).',
    typicalFamilies: ['GELD-GELD-TERUGREKENEN'],
  },
  {
    id: 'geld.dubbele-verhoging',
    label: 'Past verhoging dubbel toe',
    module: 'Geld',
    description:
      'Leerling telt de verhoging er nog een keer bij op de al-verhoogde prijs.',
    typicalFamilies: ['GELD-GELD-TERUGREKENEN'],
  },
  {
    id: 'geld.verkeerd-deelpercentage',
    label: 'Deelt door verkeerd percentage',
    module: 'Geld',
    description:
      'Leerling deelt door het verkeerde percentage bij terugrekenen (bijv. door 0,60 i.p.v. 0,75 bij 25% korting).',
    typicalFamilies: ['GELD-GELD-TERUGREKENEN'],
  },
  {
    id: 'geld.divide-by-10-not-100',
    label: 'Deelt door 10 i.p.v. 100 bij percentage',
    module: 'Geld',
    description:
      'Leerling deelt bedrag × percentage door 10 in plaats van 100 (€500 × 4 ÷ 10 = €200 i.p.v. €20).',
    typicalFamilies: ['GELD-RENTE-PROC', 'GELD-KORTING', 'GELD-BTW'],
  },
  {
    id: 'geld.divide-by-1000-not-100',
    label: 'Deelt door 1000 i.p.v. 100 bij percentage',
    module: 'Geld',
    description:
      'Leerling deelt bedrag × percentage door 1000 in plaats van 100 (€500 × 4 ÷ 1000 = €2 i.p.v. €20).',
    typicalFamilies: ['GELD-RENTE-PROC', 'GELD-KORTING', 'GELD-BTW'],
  },
  {
    id: 'geld.double-percentage',
    label: 'Verdubbelt het percentage',
    module: 'Geld',
    description:
      'Leerling rekent met het dubbele percentage (4% → 8%) zonder reden.',
    typicalFamilies: ['GELD-RENTE-PROC', 'GELD-KORTING', 'GELD-BTW'],
  },
  {
    id: 'geld.only-one-year-rente',
    label: 'Berekent rente voor slechts 1 jaar i.p.v. meerdere',
    module: 'Geld',
    description:
      'Leerling negeert het aantal jaren en rekent alleen de jaarrente — over 2 of 3 jaar levert dit een te laag bedrag op.',
    typicalFamilies: ['GELD-RENTE-PROC'],
  },
  {
    id: 'geld.multiply-percentages-not-add',
    label: 'Vermenigvuldigt percentages i.p.v. ze te combineren',
    module: 'Geld',
    description:
      'Leerling denkt dat 5% per jaar × 2 jaar = 50% rente in plaats van 10% (enkelvoudig) of ~10,25% (samengesteld).',
    typicalFamilies: ['GELD-RENTE-PROC'],
  },
  {
    id: 'geld.percentage-of-wrong-base',
    label: 'Behandelt percentage als vast bedrag',
    module: 'Geld',
    description:
      'Leerling interpreteert 5% letterlijk als €5 (of 21% als €21) ongeacht het bedrag — percentage-als-vast-bedrag fout.',
    typicalFamilies: ['GELD-RENTE-PROC', 'GELD-BTW', 'GELD-KORTING'],
  },
  {
    id: 'geld.enkelvoudig-ipv-samengesteld',
    label: 'Berekent enkelvoudige i.p.v. samengestelde rente',
    module: 'Geld',
    description:
      'Leerling vermenigvuldigt de jaarrente met het aantal jaren in plaats van rente-op-rente toe te passen.',
    typicalFamilies: ['GELD-RENTE-PROC'],
  },
  {
    id: 'geld.add-percentages-instead-of-multiply',
    label: 'Telt percentages verkeerd op bij samengestelde rente',
    module: 'Geld',
    description:
      'Leerling telt 10% + 10% + 10% = 30% in plaats van 1,10³ = 33,1% bij samengestelde rente over meerdere jaren.',
    typicalFamilies: ['GELD-RENTE-PROC'],
  },
]
